
import React from "react";
import PricingCard from "@/components/pricing/PricingCard";

interface UniversalPlanProps {
  hasActiveSubscription: boolean;
  onSubscribe: () => void;
  isCheckoutLoading: boolean;
}

const UniversalPlan: React.FC<UniversalPlanProps> = ({
  hasActiveSubscription,
  onSubscribe,
  isCheckoutLoading
}) => {
  const plan = {
    name: "Universal Subscription",
    price: "€1",
    period: "first month, then €29.99/month",
    features: [
      "Unlimited AI Staff members for your business",
      "All Senior-level AI capabilities",
      "Full marketing automation tools and templates",
      "Unlimited tasks and content generation",
      "Free updates as new AI capabilities are released",
      "Cancel anytime - No long-term commitment"
    ],
    recommended: false, // Remove recommended flag
    callToAction: "Subscribe Now",
    specialOffer: {
      enabled: true,
      text: "Limited Time Offer - First Month Only €1!"
    },
    isSubscribed: hasActiveSubscription,
    isProcessing: isCheckoutLoading
  };

  return (
    <PricingCard 
      {...plan}
      onSelectPlan={onSubscribe}
    />
  );
};

export default UniversalPlan;
